import header from "./two-different-floorplans.webp";
import section1 from "./laptop-grundriss.webp";
import section2 from "./floorplan.png";
import section3 from "./3-different-floorplantypes.webp";
import section4 from "./immobilienmakler-besichtigung.webp";
import section5 from "./immobilienmakler-schluesseluebergabe.webp";

export { header, section1, section2, section3, section4, section5 };
